import SimpleFlowchart from './components/SimpleFlowChart.vue';
export default SimpleFlowchart;
